import React, { useState } from "react";
import Widget from "./Widget";
import AddWidgetModal from "./AddWidgetModal";

const CATEGORY_ICONS = {
  cspm: "🛡",
  cwpp: "☁",
  registry: "🔍",
};

const CATEGORY_COLORS = {
  cspm: "#6366f1",
  cwpp: "#06b6d4",
  registry: "#8b5cf6",
};

export default function Category({ category, allCategories, onAdd, onRemove }) {
  const [showModal, setShowModal] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const icon = CATEGORY_ICONS[category.id] || "📋";
  const color = CATEGORY_COLORS[category.id] || "#6366f1";

  return (
    <div className="category">
      <div className="category-header">
        <div className="category-title-row">
          <span className="category-icon" style={{ color }}>{icon}</span>
          <h3 className="category-title">{category.name}</h3>
          <span className="category-count">{category.widgets.length} widgets</span>
        </div>
        <div className="category-actions">
          <button className="cat-action-btn" onClick={() => setCollapsed(!collapsed)}>
            {collapsed ? "▼ Expand" : "▲ Collapse"}
          </button>
        </div>
      </div>

      {!collapsed && (
        <div className="widgets-grid">
          {category.widgets.map((widget) => (
            <Widget
              key={widget.id}
              widget={widget}
              categoryId={category.id}
              onRemove={onRemove}
            />
          ))}

          {/* Add Widget Placeholder */}
          <div className="widget widget-placeholder" onClick={() => setShowModal(true)}>
            <div className="placeholder-inner">
              <span className="add-widget-icon">+</span>
              <span className="add-widget-label">Add Widget</span>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <AddWidgetModal
          category={category}
          allCategories={allCategories}
          onAdd={onAdd}
          onRemove={onRemove}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
}
